/* global $ */
import { focusTrap } from '../utils';

class MobileMenu {
  constructor() {
    this.$window = $(window);
    this.$body = $('body');
    this.$mobileMenuButton = $('.js-mobile-menu');
    this.$mobileMenu = $('.mobile-menu');

    this.focusTrapCleanup = null;

    this.init();
  }

  init() {
    this.$mobileMenuButton.on('click.mobileMenu', this.onClick.bind(this));
    this.$window.on('resize.mobileMenu', this.closeMenu.bind(this));
    this.$window.on('keydown.mobileMenu', this.escMenu.bind(this));
  }

  onClick() {
    if (this.$body.hasClass('js-site-menu-open')) {
      this.closeMenu();
    } else {
      this.$body.addClass('js-site-menu-open');
      this.focusTrapCleanup = focusTrap($('.mobile-menu'), $('.js-mobile-menu'));
    }
  }

  escMenu(evt) {
    if (evt.which === 27) {
      evt.preventDefault();
      this.closeMenu();
    }
  }

  closeMenu() {
    this.$body.removeClass('js-site-menu-open');

    if (this.focusTrapCleanup) {
      this.focusTrapCleanup();
    }
  }

  deinit() {
    this.closeMenu();
    this.$mobileMenuButton.off('click.mobileMenu');
    this.$window.off('resize.mobileMenu');
    this.$window.off('keydown.mobileMenu');
  }
}

export default MobileMenu;
